import {
  observable,
  action,
  toJS
} from 'mobx';
import base from '../../tool/base';
import {
  message
} from 'antd';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken
} = util;
export class DevStore {

  constructor(routing) {
    this.routing = routing;
  }
  @observable devApps = [];
  @observable devCount = 0;
  @observable current = 1;
  @observable pageSize = 19;
  @observable loading = false;
  @observable currentStatus = 0;
  @observable appType = 0;
  @observable appDetail = {};
  @observable license = {};
  @observable logger = [];
  @observable member = [];
  @observable initMember = [];
  @observable genre = [];
  @observable genreModule = [];
  @observable guysVisible = false;
  @observable guysCurrent = 1;
  @observable guysPageSize = 5;
  @observable guysList = [];
  @observable guysCount = 0;
  @observable guysLoading = false;
  @observable guysSelectedRowKeys = [];
  @observable guysSelectedRows = [];
  @observable guysSearchName = '';
  @observable licenseVisible = false;
  @observable licenseData = {};
  @observable activeKey = '0';
  @observable devSearchValue = '';
  @observable authKey = '';
  @observable authDevKey = '';
  @observable devActiveKey = 'list'
  @observable developKey = "";
  @observable developKeyLoading = false;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
    return this;
  }
  @action
  initForm = () => {
    this.currentStatus = 0;
    this.appDetail = {};
  }
  @action
  messageConfig = () => {
    message.config({
      top: 20,
    });
  }
  @action
  getDevApps = (params = {}) => {
    this.loadingApps = true;
    const s_status = this.activeKey === '0' ? '0,1,2' : '3';
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
      idDe: 1,
      s_status,
    };
    base.callApi('/v1/sys/app', 'GET', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
      this.loadingApps = false;
      const lastDevApps = this.devApps || [];
      this.hasMore = lastDevApps.length < data.count && data.app.length !== 0;
      this.devApps = param.current === 1 ? data.app : [...toJS(lastDevApps), ...data.app];
      this.devCount = data.count;
    });
  }
  @action
  init = () => {
    this.current = 1;
    this.hasMore = true;
    this.loadingApps = false;
    this.devApps = [];
    this.devCount = 0;
    this.devSearchValue = '';
  }
  @action
  getDevAppDetail = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/sys/app/' + params.s_id, 'POST', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'true') {
          this.license = data.license;
          this.logger = data.logger;
          this.member = data.member;
          this.initMember = data.member;
          this.appDetail = {
            ...data.app,
            c_name: data.license.dl_cname,
            license: data.license.dl_license,
          };
          resolve(data);
        } else {
          this.messageConfig();
          message.error(data.message || '操作失败');
        }
      });
    })
  }
  @action
  applyAppDevCodeP = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/app/add', 'POST', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'false') {
          this.messageConfig();
          message.error(data.msg || '操作失败');
        } else {
          resolve(data);
        }
      });
    })
  }
  @action
  changeCheckboxData = (params = {}) => {
    const keys = ['s_apptype', 's_trade', 's_type', 's_inter', 's_ec', 's_database', 's_stype'];
    keys.forEach(v => {
      if (params[v] && typeof params[v] === 'object') params[v] = params[v].join();
    });
    return params;
  }
  @action
  getParams = (values = {}) => {
    let params = {
      ...values,
    };
    Object.keys(values).forEach(v => {
      if (v === 'docfile' || v === 'usefile' || v === 'logofile' || v === 'appfile' || v === 'srcfile') {
        params[`file_${v}`] = values[v] ? values[v].map((k) => (k.response ? k.response.id : '')).join() : [];
        params[v] = [];
      } else if (v === 'sDocfile') {
        params[`file_${v}`] = values[v] ? values[v].map((k) => (k.response ? k.response.id : '')).join() : [];
        params['s_docfile'] = values[v] ? values[v].map((k) => k.response ? k.response.url : '').join() : [];
        params[v] = [];
      } else {
        params[v] = values[v];
      }
    });
    params.opType = values.opType || 'edit';
    params.opName = values.opName || '修改';
    params.s_id = this.appDetail.s_id;
    params.s_number = this.appDetail.s_number;
    params.s_status = values.s_status || this.appDetail.s_status;
    params = this.changeCheckboxData(params);
    return params;
  }
  @action
  addApplyDev = (values = {}) => {

    this.loading = true;
    const params = this.getParams(values);
    const param = {
      app: JSON.stringify(params),
      desc: params.s_desc || '',
      versiondesc: params.s_versiondesc || '',
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/app/' + this.appDetail.s_id + '/edit', 'POST', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'false') {
          this.messageConfig();
          message.error(data.msg || '操作失败');
        } else {
          resolve(data);
        }
      });
    })
  }
  @action
  getGenre = (params = {}) => {
    this.loading = true;
    const param = {
      type: "y",
      ...params,
      gorder: 0,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/genre', 'GET', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'true') {
          if (param.type === 'y') this.genre = data.genre;
          else this.genreModule = data.genre;
          resolve(data);
        } else {
          this.messageConfig();
          message.error(data.msg || '操作失败');
        }
      });
    })
  }
  @action
  upedit = (bool) => {
    this.loading = true;
    const params = {
      s_close: bool,
      access_token: getAccessToken()
    }
    return new Promise(resolve => {
      base.callApi('/v1/sys/app/' + this.appDetail.sw_id + "/upedit", 'POST', params, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'false') {
          this.messageConfig();
          message.error(data.msg || '操作失败');
        } else {
          this.appDetail = {
            ...this.appDetail,
            s_close: data.s_close,
          }
          resolve(data);
        }
      });
    })
  }
  @action
  changeCheckboxData2 = (app, keys) => {
    let params = {};
    keys.forEach(v => {
      params[v] = app[v] && app[v] !== '' ? app[v].split(',') : [];
    });
    return params;
  }
  @action getHash = (prefix) => prefix + Math.random().toString(36).substr(2, 6);
  @action
  updateForm = (form, app, step) => {
    const currentStatus = parseInt(this.currentStatus, 10);
    //form参数分开，去除警告
    const sDocfile = [{
      url: app.s_docfile,
      docId: "",
      name: app.s_docfile.split('/').reverse()[0],
      status: "done",
      thumbUrl: "",
      tokenKey: "",
      uid: this.getHash('s_docfile'),
    }];
    let params = {
      s_name: app.s_name,
      s_version: app.s_version,
    }
    if (this.appType === 2) {
      params = {
        ...params,
        s_uuid: app.s_uuid,
      }
    }
    if (currentStatus > 1) {
      const keys = ['s_trade', 's_type', 's_apptype', 's_stype', 's_inter', 's_ec', 's_database'];
      const splitRes = this.changeCheckboxData2(app, keys);
      params = {
        ...params,
        ...splitRes,
        s_ecdesc: app.s_ecdesc,
        s_ispersonal: app.s_ispersonal !== 'false',
        s_beta: app.s_beta !== 'false',
        s_nowversion: app.s_nowversion,
        appfile: app.appfile,
        srcfile: app.srcfile,
        s_docfile: app.s_docfile,
        s_svnacc: app.s_svnacc,
        usefile: app.usefile,
        logofile: app.logofile,
        docfile: app.docfile,
        sDocfile,
        s_price: app.s_price,
        s_tuijianprice: app.s_tuijianprice,
        s_desc: app.s_desc,
        s_versiondesc: app.s_versiondesc,
        page: app.page,
        pageMobile: app.pageMobile,
      }
    } else {
      if (step === 0) {
        const keys = ['s_apptype'];
        const splitRes = this.changeCheckboxData2(app, keys);
        params = {
          ...params,
          ...splitRes,
          page: app.page,
          pageMobile: app.pageMobile,
        }
      } else if (step === 1) {
        const keys = ['s_trade', 's_type', 's_inter', 's_ec', 's_database'];
        const splitRes = this.changeCheckboxData2(app, keys);
        params = {
          ...params,
          ...splitRes,
          s_ecdesc: app.s_ecdesc,
          docfile: app.docfile,
          s_price: app.s_price,
          s_tuijianprice: app.s_tuijianprice,
        }
      } else if (step === 2) {
        params = {
          ...params,
          s_desc: app.s_desc,
        };
      } else {
        const keys = ['s_stype'];
        const splitRes = this.changeCheckboxData2(app, keys);
        params = {
          ...params,
          ...splitRes,
          s_beta: app.s_beta !== 'false',
          s_nowversion: app.s_nowversion,
          usefile: app.usefile,
          logofile: app.logofile,
          appfile: app.appfile,
          srcfile: app.srcfile,
          sDocfile: sDocfile,
          s_svnacc: app.s_svnacc,
          s_ispersonal: app.s_ispersonal !== 'false',
          s_versiondesc: app.s_versiondesc,
        };
      }
    }
    form.setFieldsValue({
      ...params,
      c_name: app.c_name,
      license: app.license,
    });
  }
  @action
  getPerson = (params = {}) => {
    this.guysLoading = true;
    const guysCurrent = params.guysCurrent || this.guysCurrent;
    const guysPageSize = params.guysPageSize || this.guysPageSize;
    const min = (guysCurrent - 1) * guysPageSize + 1;
    const max = min + guysPageSize - 1;
    delete params.guysCurrent;
    delete params.guysPageSize;
    const param = {
      ...params,
      min,
      max,
      selme: "1",
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/person', 'GET', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.guysLoading = false;
        if (data.status === 'false') {
          this.messageConfig();
          message.error(data.msg || '操作失败');
        } else {
          this.guysList = data.List;
          this.guysCount = data.count;
          resolve(data);
        }
      });
    })
  }
  @action
  saveGuys = () => {
    this.loading = true;
    const res = toJS(this.member).map(el => {
      return {
        M_id: el.m_id,
        M_softrole: el.m_softrole || "",
        M_role: el.m_role,
      }
    });
    const param = {
      members: JSON.stringify(res),
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/smember/' + this.appDetail.s_number + '/edit', 'POST', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        this.messageConfig();
        if (data.status === 'false') {
          message.error(data.msg || '操作失败');
        } else {
          message.success(data.msg || '保存成功');
          this.member = data.mlist;
          resolve(data);
        }
      });
    })
  }
  @action
  getLicense = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      s_id: toJS(this.appDetail).s_id,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v1.1/license', 'POST', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
        this.loading = false;
        if (data.status === 'false') {
          message.error(data.msg || '操作失败');
        } else {
          this.licenseVisible = true;
          this.licenseData = data;
          resolve(data);
        }
      });
    })
  }
  @action
  queryDeapp = (params = {}) => {
    this.loadingApps = true;
    const s_status = this.activeKey === '0' ? '0,1,2' : '3';
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
      idDe: 1,
      s_status,
      s_name: this.devSearchValue,
    };
    base.callApi('/v1/sys/queryDeapp', 'GET', param, "json", "text").then((data) => catchApiError(data, this.routing)).then((data) => {
      this.loadingApps = false;
      const lastDevApps = this.devApps || [];
      this.hasMore = lastDevApps.length < data.count && data.app.length !== 0;
      this.devApps = param.current === 1 ? data.app : [...toJS(lastDevApps), ...data.app];
      this.devCount = data.count;
    });
  }
  @action
  initEcodeApply = () => {
    this.authKey = '';
    this.authDevKey = '';
    this.devActiveKey = 'list';
  }
  @action
  applyAuthKey = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v5/apply/applyWithKey', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.api_status) {
          message.success('申请成功');
        } else {
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }
  @action
  applyDevAuthKey = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise(resolve => {
      base.callApi('/v5/apply/temporaryAuth', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.api_status) {
          message.success('申请成功');
        } else {
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }
  //开发授权
  @action
  getDevelopKey = (params = {}) => {
    this.developKeyLoading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise((resolve, reject) => {
      base.callApi('/v5/apply/developKey', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status) {
          this.developKey = data.data;
          message.success('申请成功');
          resolve(data);
        } else {
          message.error(data.msg || "申请失败");
          reject(data);
        }
        this.developKeyLoading = false;
      });
    });
  }
  //应用授权
  @action
  appAuthorized = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise((resolve, reject) => {
      base.callApi('/v5/apply/appAuthorized', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status) {
          message.success('申请成功');
          resolve(data);
        } else {
          message.error(data.msg || "申请失败");
          reject(data);
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/dev/DevStore.js